import { useState } from "react";
import { Upload, AlertCircle, CheckCircle, TrendingDown, TrendingUp, Package, BarChart3, FileText, Download, LogOut, Users, Plus, Trash2, Eye, EyeOff, ShieldCheck, Lock } from "lucide-react";

// ── Base de dados em memória ─────────────────────────
let USERS = [
  { id:"1", username:"gabriel",  password:"99176500", role:"admin", active:true, name:"Gabriel Pereira" },
  { id:"2", username:"jussan",   password:"784523",   role:"user",  active:true, name:"Jussan" },
  { id:"3", username:"paulo",    password:"784523",   role:"user",  active:true, name:"Paulo Mendes" },
  { id:"4", username:"ualisson", password:"784523",   role:"user",  active:true, name:"Ualisson" },
  { id:"5", username:"ronan",    password:"784523",   role:"user",  active:true, name:"Ronan" },
];
let SESSION = null;

// ── Análise de produto ───────────────────────────────
function classificarProduto(p, prods, totFat, mVenda, mMD, medCurva) {
  const problemas = [];
  const pontos = [];
  let risco = 0;
  let acao = "";

  p.participacaoFamilia = totFat > 0 ? (p.faturamentoMensal / totFat) * 100 : 0;
  const giro = p.vendaMensal > 0 ? p.estoque / p.vendaMensal : (p.estoque > 0 ? 999 : 0);
  p.giroEstoque = giro;
  const dvf = mVenda > 0 ? (p.vendaMensal / mVenda) * 100 : 0;
  const mc = medCurva[p.curva];
  const dvc = mc && mc.mediaVenda > 0 ? (p.vendaMensal / mc.mediaVenda) * 100 : 0;
  p.desempenhoVsFamilia = dvf;
  p.desempenhoVsCurva = dvc;
  const pMD = mMD > 0 ? (p.markdown / mMD) * 100 : 0;
  p.percentualMarkdown = pMD;

  // Pontos positivos
  if (p.vendaMensal > 0 && giro > 0 && giro <= 2)
    pontos.push("Giro excelente: estoque cobre apenas " + giro.toFixed(1) + " mes(es)");
  if (p.vendaMensal > 0 && giro > 2 && giro <= 4)
    pontos.push("Giro saudavel: estoque para " + giro.toFixed(1) + " meses");
  if (dvf >= 120)
    pontos.push("Venda " + dvf.toFixed(0) + "% acima da media da familia");
  if (pMD >= 110)
    pontos.push("Rentabilidade acima da media: Markdown " + p.markdown.toFixed(1) + "% (" + pMD.toFixed(0) + "% da media)");
  if (p.curva === "A" && p.vendaMensal >= mVenda)
    pontos.push("Curva A com venda acima da media da familia");

  // Sem vendas
  if (p.vendaTotal6Meses === 0) {
    problemas.push("Nenhuma venda nos ultimos 6 meses");
    risco += 6;
    acao = "Descontinuar imediatamente";
  }

  // Estoque vs giro
  if (p.vendaTotal6Meses > 0) {
    if (giro > 12) {
      problemas.push("Estoque critico: " + p.estoque + " un. para " + giro.toFixed(1) + " meses (venda " + p.vendaMensal.toFixed(1) + "/mes)");
      risco += 5;
      if (!acao) acao = "URGENTE: Promover liquidacao";
    } else if (giro > 6 && dvf < 80) {
      problemas.push("Estoque elevado: " + p.estoque + " un. para " + giro.toFixed(1) + " meses de venda");
      risco += 2;
    }
  }

  // Desempenho vs curva ABC
  if (p.vendaTotal6Meses > 0 && mc && mc.totalProdutos >= 3) {
    if (dvc < 40) {
      problemas.push("Venda " + p.vendaMensal.toFixed(1) + "/mes = " + dvc.toFixed(0) + "% da media Curva " + p.curva + " (" + mc.mediaVenda.toFixed(1) + "/mes)");
      risco += 3;
    } else if (dvc < 65) {
      problemas.push("Venda abaixo da media da Curva " + p.curva + ": " + p.vendaMensal.toFixed(1) + " vs " + mc.mediaVenda.toFixed(1) + "/mes");
      risco += 1;
    }
  }

  // Curva A com desempenho ruim
  if (p.curva === "A" && p.vendaMensal > 0 && dvf < 60) {
    problemas.push("Curva A mas vende apenas " + dvf.toFixed(0) + "% da media da familia");
    risco += 2;
  }

  // Markdown (so penaliza se vendas tambem ruins)
  if (p.vendaTotal6Meses > 0 && pMD > 0 && pMD < 50) {
    if (dvf < 70) {
      problemas.push("Baixa rentabilidade: Markdown " + p.markdown.toFixed(1) + "% (" + pMD.toFixed(0) + "% da media " + mMD.toFixed(1) + "%)");
      risco += 2;
    } else {
      problemas.push("Rentabilidade abaixo da media: Markdown " + p.markdown.toFixed(1) + "% vs " + mMD.toFixed(1) + "% — revisar precificacao");
      risco += 1;
    }
  }

  // Participacao insignificante so se vendas ruins
  if (p.participacaoFamilia < 0.5 && prods.length > 5 && dvf < 40 && p.vendaTotal6Meses > 0) {
    problemas.push("Participacao muito baixa: " + p.participacaoFamilia.toFixed(2) + "% do faturamento da familia");
    risco += 1;
  }

  if (!acao) {
    if (risco >= 8)      acao = "CRITICO: Descontinuar ou liquidar imediatamente";
    else if (risco >= 5) acao = "ALTA PRIORIDADE: Avaliar descontinuacao";
    else if (risco >= 3) acao = "ATENCAO: Monitorar de perto";
    else if (risco >= 1) acao = "Monitorar — pequenos pontos de melhoria";
    else                 acao = "Manter no mix — produto saudavel";
  }

  p.criteriosNaoSadios = problemas;
  p.pontosPositivos = pontos;
  p.pontuacaoRisco = risco;
  p.status = risco >= 5 ? "nao sadio" : risco >= 2 ? "atencao" : "sadio";
  p.acaoRecomendada = acao;
  return p;
}

function processarCSV(rawData) {
  const pd = rawData.map(function(row) {
    var ma=parseFloat(row["mes_atual"])||0, m1=parseFloat(row["mes1"])||0,
        m2=parseFloat(row["mes_2"])||0,   m3=parseFloat(row["mes_3"])||0,
        m4=parseFloat(row["mes_4"])||0,   m5=parseFloat(row["mes_5"])||0,
        vt=ma+m1+m2+m3+m4+m5;
    return {
      codItem:row["coditem"], descricao:row["descricao"], codigoBarras:row["codbarra"],
      custo:parseFloat(row["custo"])||0, unitario:parseFloat(row["unitario"])||0,
      markdown:parseFloat(row["markdown"])||0, curva:(row["curvaabc"]||"").toUpperCase(),
      grupo:row["grupo"], familia:row["descricaofamilia"],
      estoque:parseFloat(row["estoque"])||0,
      vendaTotal6Meses:vt, vendaMensal:vt/6,
      vendaMesAtual:ma, vendaMes1:m1, vendaMes2:m2, vendaMes3:m3, vendaMes4:m4, vendaMes5:m5
    };
  });
  pd.forEach(function(p) {
    p.faturamentoMensal = p.unitario * p.vendaMensal;
    p.faturamentoTotal6Meses = p.unitario * p.vendaTotal6Meses;
  });

  var ativos = pd.filter(function(p){ return p.estoque > 0 || p.vendaTotal6Meses > 0; });
  var familias = {};
  ativos.forEach(function(p){ if(!familias[p.familia]) familias[p.familia]=[]; familias[p.familia].push(p); });

  var fa = {};
  Object.keys(familias).forEach(function(fn) {
    var prods = familias[fn];
    var totFat = prods.reduce(function(s,p){return s+p.faturamentoTotal6Meses;},0);
    var mVenda = prods.reduce(function(s,p){return s+p.vendaMensal;},0) / prods.length;
    var mMD    = prods.reduce(function(s,p){return s+p.markdown;},0) / prods.length;

    var byCurva = {A:prods.filter(function(p){return p.curva==="A";}),B:prods.filter(function(p){return p.curva==="B";}),C:prods.filter(function(p){return p.curva==="C";}),D:prods.filter(function(p){return p.curva==="D";})};
    var medCurva = {};
    Object.keys(byCurva).forEach(function(c){
      var pc = byCurva[c];
      if(pc.length) medCurva[c] = {
        mediaVenda: pc.reduce(function(s,p){return s+p.vendaMensal;},0)/pc.length,
        mediaFaturamento: pc.reduce(function(s,p){return s+p.faturamentoMensal;},0)/pc.length,
        mediaEstoque: pc.reduce(function(s,p){return s+p.estoque;},0)/pc.length,
        totalProdutos: pc.length
      };
    });

    var classified = prods.map(function(p){ return classificarProduto(p, prods, totFat, mVenda, mMD, medCurva); });
    var ns = classified.filter(function(p){return p.status==="nao sadio";});
    var at = classified.filter(function(p){return p.status==="atencao";});
    fa[fn] = {
      produtos:classified, totalProdutos:classified.length,
      produtosNaoSadios:ns.length, produtosAtencao:at.length,
      produtosSadios:classified.length-ns.length-at.length,
      totalFaturamento:totFat, mediaVendaFamilia:mVenda, mediaMarkdownFamilia:mMD
    };
  });

  var tot=ativos.length;
  var tns=Object.values(fa).reduce(function(s,f){return s+f.produtosNaoSadios;},0);
  var tat=Object.values(fa).reduce(function(s,f){return s+f.produtosAtencao;},0);
  return {
    familias: fa,
    resumo: {
      totalProdutos:tot, totalNaoSadios:tns, totalAtencao:tat, totalSadios:tot-tns-tat,
      percentualNaoSadios:(tns/tot*100).toFixed(1),
      percentualAtencao:(tat/tot*100).toFixed(1),
      percentualSadios:((tot-tns-tat)/tot*100).toFixed(1),
      totalFaturamento:ativos.reduce(function(s,p){return s+p.faturamentoTotal6Meses;},0),
      totalFamilias:Object.keys(fa).length
    }
  };
}

// ════════════════════════════════════════════════════
// LOGIN
// ════════════════════════════════════════════════════
function LoginScreen({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw]     = useState(false);
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  function handleLogin() {
    setLoading(true); setError("");
    var user = USERS.find(function(u){ return u.username===username && u.password===password; });
    if (!user)         { setError("Usuario ou senha incorretos.");          setLoading(false); return; }
    if (!user.active)  { setError("Usuario inativo. Contate o administrador."); setLoading(false); return; }
    SESSION = { id:user.id, username:user.username, role:user.role, name:user.name };
    onLogin(SESSION);
    setLoading(false);
  }

  var inp = {width:"100%",background:"#0f172a",border:"1px solid #475569",borderRadius:8,padding:"0.75rem 1rem",color:"#fff",fontSize:"0.9rem",outline:"none",boxSizing:"border-box"};

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0f172a,#1e293b,#0f172a)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1rem"}}>
      <div style={{width:"100%",maxWidth:400}}>
        <div style={{textAlign:"center",marginBottom:"2rem"}}>
          <div style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:64,height:64,borderRadius:"50%",background:"rgba(59,130,246,0.15)",border:"1px solid #3b82f6",marginBottom:"1rem"}}>
            <Lock color="#60a5fa" size={32}/>
          </div>
          <h1 style={{fontSize:"1.8rem",fontWeight:700,background:"linear-gradient(90deg,#60a5fa,#22d3ee)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",margin:0}}>Pereira MixControl</h1>
          <p style={{color:"#94a3b8",marginTop:4,fontSize:"0.9rem"}}>Faca login para continuar</p>
        </div>
        <div style={{background:"#1e293b",borderRadius:16,border:"1px solid #334155",padding:"2rem"}}>
          <div style={{marginBottom:"1.2rem"}}>
            <label style={{display:"block",color:"#cbd5e1",fontSize:"0.85rem",marginBottom:6,fontWeight:500}}>Usuario</label>
            <input style={inp} value={username} onChange={function(e){setUsername(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")handleLogin();}} placeholder="seu.usuario"/>
          </div>
          <div style={{marginBottom:"1.2rem"}}>
            <label style={{display:"block",color:"#cbd5e1",fontSize:"0.85rem",marginBottom:6,fontWeight:500}}>Senha</label>
            <div style={{position:"relative"}}>
              <input style={{...inp,paddingRight:"2.5rem"}} type={showPw?"text":"password"} value={password} onChange={function(e){setPassword(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")handleLogin();}} placeholder="••••••••"/>
              <button onClick={function(){setShowPw(!showPw);}} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"#64748b",cursor:"pointer",padding:0}}>
                {showPw ? <EyeOff size={18}/> : <Eye size={18}/>}
              </button>
            </div>
          </div>
          {error && <div style={{display:"flex",alignItems:"center",gap:8,color:"#f87171",fontSize:"0.85rem",background:"rgba(239,68,68,0.1)",border:"1px solid #7f1d1d",borderRadius:8,padding:"0.6rem 0.8rem",marginBottom:"1rem"}}><AlertCircle size={16}/>{error}</div>}
          <button onClick={handleLogin} disabled={loading||!username||!password} style={{width:"100%",padding:"0.8rem",background:"#2563eb",border:"none",borderRadius:8,color:"#fff",fontWeight:600,fontSize:"0.95rem",cursor:loading||!username||!password?"not-allowed":"pointer",opacity:loading||!username||!password?0.5:1}}>
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </div>
        <p style={{textAlign:"center",color:"#475569",fontSize:"0.75rem",marginTop:"1rem"}}>Acesso restrito a usuarios autorizados</p>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════
// ADMIN PANEL
// ════════════════════════════════════════════════════
function AdminPanel({ currentUser, onBack }) {
  const [users, setUsers]   = useState([...USERS]);
  const [showAdd, setShowAdd] = useState(false);
  const [newUser, setNewUser] = useState({name:"",username:"",password:"",role:"user"});
  const [msg, setMsg]         = useState(null);

  function flash(text, type) { setMsg({text:text, type:type||"success"}); setTimeout(function(){setMsg(null);},4000); }

  function addUser() {
    if (!newUser.name||!newUser.username||!newUser.password) return flash("Preencha todos os campos.","error");
    if (USERS.find(function(u){return u.username===newUser.username;})) return flash("Usuario ja existe.","error");
    var novo = {id:Date.now().toString(), name:newUser.name, username:newUser.username, password:newUser.password, role:newUser.role, active:true};
    USERS.push(novo);
    setUsers([...USERS]);
    setNewUser({name:"",username:"",password:"",role:"user"});
    setShowAdd(false);
    flash("Usuario " + novo.username + " criado!");
  }

  function toggleActive(u) {
    if (u.id===currentUser.id) return flash("Voce nao pode desativar sua propria conta.","error");
    USERS = USERS.map(function(x){ return x.id===u.id ? {...x,active:!u.active} : x; });
    setUsers([...USERS]);
    flash("Status atualizado!");
  }

  function deleteUser(u) {
    if (u.id===currentUser.id) return flash("Voce nao pode excluir sua propria conta.","error");
    USERS = USERS.filter(function(x){ return x.id!==u.id; });
    setUsers([...USERS]);
    flash("Usuario removido!");
  }

  function toggleRole(u) {
    if (u.id===currentUser.id) return flash("Voce nao pode alterar seu proprio perfil.","error");
    var nr = u.role==="admin" ? "user" : "admin";
    USERS = USERS.map(function(x){ return x.id===u.id ? {...x,role:nr} : x; });
    setUsers([...USERS]);
    flash("Perfil atualizado!");
  }

  var si = {background:"#0f172a",border:"1px solid #475569",borderRadius:8,padding:"0.6rem 0.8rem",color:"#fff",fontSize:"0.85rem",outline:"none",width:"100%",boxSizing:"border-box"};

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0f172a,#1e293b,#0f172a)",color:"#fff",padding:"1.5rem"}}>
      <div style={{maxWidth:860,margin:"0 auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"2rem"}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <ShieldCheck color="#818cf8" size={28}/>
            <div>
              <h1 style={{margin:0,fontSize:"1.4rem",fontWeight:700}}>Central de Usuarios</h1>
              <p style={{margin:0,color:"#94a3b8",fontSize:"0.82rem"}}>Gerencie o acesso ao Pereira MixControl</p>
            </div>
          </div>
          <button onClick={onBack} style={{display:"flex",alignItems:"center",gap:6,padding:"0.5rem 1rem",background:"#334155",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:"0.85rem"}}>
            <BarChart3 size={16}/>Voltar
          </button>
        </div>

        {msg && <div style={{marginBottom:"1rem",padding:"0.7rem 1rem",borderRadius:8,display:"flex",alignItems:"center",gap:8,fontSize:"0.85rem",background:msg.type==="error"?"rgba(239,68,68,0.15)":"rgba(34,197,94,0.15)",border:"1px solid "+(msg.type==="error"?"#7f1d1d":"#14532d"),color:msg.type==="error"?"#f87171":"#4ade80"}}>
          {msg.type==="error" ? <AlertCircle size={16}/> : <CheckCircle size={16}/>}{msg.text}
        </div>}

        <div style={{background:"#1e293b",borderRadius:16,border:"1px solid #334155",padding:"1.5rem"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1.2rem"}}>
            <h2 style={{margin:0,display:"flex",alignItems:"center",gap:8,fontSize:"1.1rem"}}><Users size={20} color="#22d3ee"/>Usuarios ({users.length})</h2>
            <button onClick={function(){setShowAdd(!showAdd);}} style={{display:"flex",alignItems:"center",gap:6,padding:"0.5rem 1rem",background:"#2563eb",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:"0.85rem",fontWeight:500}}><Plus size={16}/>Novo Usuario</button>
          </div>

          {showAdd && (
            <div style={{background:"rgba(15,23,42,0.6)",borderRadius:12,border:"1px solid #475569",padding:"1.2rem",marginBottom:"1.2rem"}}>
              <h3 style={{color:"#22d3ee",marginTop:0,marginBottom:"0.8rem",fontSize:"0.95rem"}}>Novo Usuario</h3>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div><label style={{display:"block",color:"#94a3b8",fontSize:"0.75rem",marginBottom:4}}>Nome</label><input style={si} value={newUser.name} onChange={function(e){setNewUser({...newUser,name:e.target.value});}} placeholder="Nome completo"/></div>
                <div><label style={{display:"block",color:"#94a3b8",fontSize:"0.75rem",marginBottom:4}}>Login</label><input style={si} value={newUser.username} onChange={function(e){setNewUser({...newUser,username:e.target.value});}} placeholder="usuario.login"/></div>
                <div><label style={{display:"block",color:"#94a3b8",fontSize:"0.75rem",marginBottom:4}}>Senha</label><input style={si} type="password" value={newUser.password} onChange={function(e){setNewUser({...newUser,password:e.target.value});}} placeholder="Senha"/></div>
                <div><label style={{display:"block",color:"#94a3b8",fontSize:"0.75rem",marginBottom:4}}>Perfil</label>
                  <select style={si} value={newUser.role} onChange={function(e){setNewUser({...newUser,role:e.target.value});}}>
                    <option value="user">Usuario</option>
                    <option value="admin">Administrador</option>
                  </select>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={addUser} style={{padding:"0.55rem 1.2rem",background:"#16a34a",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:"0.85rem",fontWeight:600}}>Criar</button>
                <button onClick={function(){setShowAdd(false);}} style={{padding:"0.55rem 1.2rem",background:"#475569",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:"0.85rem"}}>Cancelar</button>
              </div>
            </div>
          )}

          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {users.map(function(u) {
              return (
                <div key={u.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0.8rem 1rem",borderRadius:10,border:"1px solid "+(u.active?"#334155":"rgba(127,29,29,0.4)"),background:u.active?"rgba(15,23,42,0.4)":"rgba(127,29,29,0.1)"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:38,height:38,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:"0.9rem",background:u.role==="admin"?"rgba(139,92,246,0.25)":"rgba(59,130,246,0.25)",border:"1px solid "+(u.role==="admin"?"#7c3aed":"#2563eb"),color:u.role==="admin"?"#a78bfa":"#60a5fa",flexShrink:0}}>
                      {u.name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div style={{fontWeight:600,fontSize:"0.9rem"}}>{u.name}</div>
                      <div style={{color:"#94a3b8",fontSize:"0.75rem"}}>@{u.username} · {u.role==="admin"?"Administrador":"Usuario"}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <span style={{padding:"2px 10px",borderRadius:999,fontSize:"0.72rem",fontWeight:600,background:u.active?"rgba(34,197,94,0.15)":"rgba(239,68,68,0.15)",color:u.active?"#4ade80":"#f87171",border:"1px solid "+(u.active?"#14532d":"#7f1d1d")}}>{u.active?"Ativo":"Inativo"}</span>
                    <button onClick={function(){toggleActive(u);}} style={{background:u.active?"rgba(234,179,8,0.15)":"rgba(34,197,94,0.15)",border:"none",borderRadius:6,padding:"6px",cursor:"pointer",color:u.active?"#facc15":"#4ade80",display:"flex"}}>{u.active?<EyeOff size={15}/>:<Eye size={15}/>}</button>
                    <button onClick={function(){toggleRole(u);}} style={{background:"rgba(139,92,246,0.15)",border:"none",borderRadius:6,padding:"6px",cursor:"pointer",color:"#a78bfa",display:"flex"}}><ShieldCheck size={15}/></button>
                    {u.id!==currentUser.id && <button onClick={function(){deleteUser(u);}} style={{background:"rgba(239,68,68,0.15)",border:"none",borderRadius:6,padding:"6px",cursor:"pointer",color:"#f87171",display:"flex"}}><Trash2 size={15}/></button>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════
// MAIN APP
// ════════════════════════════════════════════════════
function MainApp({ session, onLogout, onAdminPanel }) {
  const [file, setFile]               = useState(null);
  const [data, setData]               = useState(null);
  const [analysis, setAnalysis]       = useState(null);
  const [error, setError]             = useState(null);
  const [activeTab, setActiveTab]     = useState("upload");
  const [selFamily, setSelFamily]     = useState(null);

  var required = ["coditem","codbarra","descricao","custo","unitario","markdown","curvaabc","grupo","descricaofamilia","estoque","mes_atual","mes1","mes_2","mes_3","mes_4","mes_5"];

  function parseCSVText(text) {
    var lines = text.split("\n").filter(function(l){return l.trim();});
    if (lines.length < 2) { setError("Arquivo CSV vazio"); return null; }
    var headers = lines[0].split(";").map(function(h){return h.trim().toLowerCase();});
    var missing = required.filter(function(c){return !headers.some(function(h){return h===c;});});
    if (missing.length > 0) { setError("Colunas faltando: " + missing.join(", ")); return null; }
    var parsed = [];
    for (var i=1; i<lines.length; i++) {
      var vals = lines[i].split(";");
      if (vals.length === headers.length) {
        var row = {};
        for (var j=0; j<headers.length; j++) {
          row[headers[j]] = vals[j].trim();
        }
        parsed.push(row);
      }
    }
    return parsed;
  }

  function hasGarbledChars(text) {
    // Detecta caracteres corrompidos típicos de latin1 lido como UTF-8
    return /Ã|â€|Â·|Ã§|Ã£|Ã¡|Ã©|Ã­|Ã³|Ãº/.test(text);
  }

  function handleFile(e) {
    var f = e.target.files[0]; if (!f) return;

    // Tenta UTF-8 primeiro
    var r1 = new FileReader();
    r1.onload = function(ev) {
      var text = ev.target.result;
      if (hasGarbledChars(text)) {
        // Tenta latin1
        var r2 = new FileReader();
        r2.onload = function(ev2) {
          try {
            var parsed = parseCSVText(ev2.target.result);
            if (!parsed) return;
            setData(parsed); setFile(f); setError(null);
            setAnalysis(processarCSV(parsed));
            setActiveTab("dashboard");
          } catch(err) { setError("Erro: " + err.message); }
        };
        r2.readAsText(f, "ISO-8859-1");
      } else {
        try {
          var parsed = parseCSVText(text);
          if (!parsed) return;
          setData(parsed); setFile(f); setError(null);
          setAnalysis(processarCSV(parsed));
          setActiveTab("dashboard");
        } catch(err) { setError("Erro: " + err.message); }
      }
    };
    r1.readAsText(f, "UTF-8");
  }

  function exportReport() {
    if (!analysis) return;
    var r = "=== RELATORIO PEREIRA MIXCONTROL ===\nData: " + new Date().toLocaleDateString("pt-BR") + "\nTotal: " + analysis.resumo.totalProdutos + " | Nao sadios: " + analysis.resumo.totalNaoSadios + "\n\n";
    Object.keys(analysis.familias).forEach(function(fn) {
      var f = analysis.familias[fn];
      r += "\nFAMILIA: " + fn + "\n" + "=".repeat(50) + "\n";
      f.produtos.filter(function(p){return p.status==="nao sadio";}).forEach(function(p,i){
        r += "\n" + (i+1) + ". " + p.descricao + " (" + p.codigoBarras + ") - Curva " + p.curva + "\n";
        p.criteriosNaoSadios.forEach(function(c){ r += "   - " + c + "\n"; });
        r += "   >> " + p.acaoRecomendada + "\n";
      });
    });
    var blob = new Blob([r],{type:"text/plain"}), url = URL.createObjectURL(blob), a = document.createElement("a");
    a.href=url; a.download="mixcontrol_"+new Date().toISOString().split("T")[0]+".txt"; a.click();
  }

  var st = {
    page: {minHeight:"100vh",background:"linear-gradient(135deg,#0f172a,#1e293b,#0f172a)",color:"#fff",padding:"1.5rem"},
    card: {background:"#1e293b",borderRadius:16,border:"1px solid #334155",padding:"1.5rem",marginBottom:"1.5rem"},
  };

  function tabStyle(id) {
    var a = activeTab===id;
    return {padding:"0.7rem 1.2rem",background:"none",border:"none",borderBottom:a?"2px solid #60a5fa":"2px solid transparent",color:a?"#60a5fa":"#94a3b8",cursor:"pointer",fontWeight:500,fontSize:"0.85rem",display:"flex",alignItems:"center",gap:6};
  }

  var statusColor = function(s){ return s==="nao sadio"?"#f87171":s==="atencao"?"#facc15":"#4ade80"; };
  var statusBg    = function(s){ return s==="nao sadio"?"#dc2626":s==="atencao"?"#d97706":"#16a34a"; };
  var statusBorder= function(s){ return s==="nao sadio"?"#7f1d1d":s==="atencao"?"#78350f":"#14532d"; };
  var cardBg      = function(s){ return s==="nao sadio"?"rgba(127,29,29,0.25)":s==="atencao"?"rgba(113,63,18,0.25)":"rgba(20,83,45,0.15)"; };

  return (
    <div style={st.page}>
      <div style={{maxWidth:1100,margin:"0 auto"}}>

        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"2rem"}}>
          <div>
            <h1 style={{margin:0,fontSize:"2rem",fontWeight:700,background:"linear-gradient(90deg,#60a5fa,#22d3ee)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Pereira MixControl</h1>
            <p style={{margin:0,color:"#94a3b8",fontSize:"0.85rem"}}>Identificacao Inteligente de Produtos Nao Sadios</p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{textAlign:"right"}}>
              <div style={{fontWeight:600,fontSize:"0.9rem"}}>{session.name}</div>
              <div style={{color:"#94a3b8",fontSize:"0.75rem"}}>{session.role==="admin"?"Administrador":"Usuario"}</div>
            </div>
            {session.role==="admin" && <button onClick={onAdminPanel} style={{background:"rgba(139,92,246,0.15)",border:"1px solid #6d28d9",borderRadius:8,padding:8,cursor:"pointer",color:"#a78bfa",display:"flex"}}><Users size={18}/></button>}
            <button onClick={onLogout} style={{background:"rgba(239,68,68,0.15)",border:"1px solid #7f1d1d",borderRadius:8,padding:8,cursor:"pointer",color:"#f87171",display:"flex"}}><LogOut size={18}/></button>
          </div>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",borderBottom:"1px solid #334155",marginBottom:"1.5rem"}}>
          {[{id:"upload",label:"Upload",icon:<Upload size={15}/>},{id:"dashboard",label:"Dashboard",icon:<BarChart3 size={15}/>},{id:"familias",label:"Por Familia",icon:<Package size={15}/>},{id:"relatorio",label:"Relatorio",icon:<FileText size={15}/>}].map(function(t){
            return <button key={t.id} onClick={function(){setActiveTab(t.id);}} disabled={t.id!=="upload"&&!analysis} style={tabStyle(t.id)}>{t.icon}{t.label}</button>;
          })}
        </div>

        {/* UPLOAD */}
        {activeTab==="upload" && (
          <div style={st.card}>
            <h2 style={{marginTop:0}}>Upload do Arquivo CSV</h2>
            <div style={{padding:"1rem",background:"rgba(37,99,235,0.1)",border:"1px solid #1d4ed8",borderRadius:10,marginBottom:"1.5rem",fontSize:"0.85rem",color:"#cbd5e1"}}>
              <strong>Delimitador:</strong> Ponto e virgula (;)<br/>
              <code style={{display:"block",background:"#0f172a",padding:"0.5rem",borderRadius:6,marginTop:8,fontSize:"0.75rem",color:"#7dd3fc"}}>coditem;codbarra;descricao;CUSTO;UNITARIO;MARKDOWN;curvaabc;GRUPO;descricaoFAMILIA;estoque;mes_atual;mes1;mes_2;mes_3;mes_4;mes_5</code>
            </div>
            <div style={{border:"2px dashed #475569",borderRadius:12,padding:"3rem",textAlign:"center"}}>
              <Upload color="#94a3b8" size={48} style={{display:"block",margin:"0 auto 1rem"}}/>
              <p style={{color:"#94a3b8",marginBottom:"1rem"}}>Arraste o CSV ou clique para selecionar</p>
              <input type="file" accept=".csv" onChange={handleFile} id="fup" style={{display:"none"}}/>
              <label htmlFor="fup" style={{display:"inline-block",padding:"0.7rem 1.5rem",background:"#2563eb",borderRadius:8,cursor:"pointer",fontWeight:600}}>Selecionar Arquivo</label>
            </div>
            {error && <div style={{marginTop:"1rem",padding:"1rem",background:"rgba(239,68,68,0.1)",border:"1px solid #7f1d1d",borderRadius:8,color:"#f87171",display:"flex",gap:8}}><AlertCircle size={18}/>{error}</div>}
            {file && !error && <div style={{marginTop:"1rem",padding:"1rem",background:"rgba(34,197,94,0.1)",border:"1px solid #14532d",borderRadius:8,color:"#4ade80",display:"flex",gap:8}}><CheckCircle size={18}/><div><strong>{file.name}</strong><br/><span style={{fontSize:"0.8rem"}}>{data&&data.length} produtos processados</span></div></div>}
          </div>
        )}

        {/* DASHBOARD */}
        {activeTab==="dashboard" && analysis && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"1rem",marginBottom:"1.5rem"}}>
              {[{l:"Total",v:analysis.resumo.totalProdutos,c:"#60a5fa"},{l:"Sadios",v:analysis.resumo.totalSadios,c:"#4ade80",s:analysis.resumo.percentualSadios+"%"},{l:"Atencao",v:analysis.resumo.totalAtencao,c:"#facc15",s:analysis.resumo.percentualAtencao+"%"},{l:"Nao Sadios",v:analysis.resumo.totalNaoSadios,c:"#f87171",s:analysis.resumo.percentualNaoSadios+"%"}].map(function(c,i){
                return <div key={i} style={{...st.card,marginBottom:0}}><div style={{color:"#94a3b8",fontSize:"0.8rem",marginBottom:4}}>{c.l}</div><div style={{fontSize:"2rem",fontWeight:700,color:c.c}}>{c.v}</div>{c.s&&<div style={{color:"#94a3b8",fontSize:"0.8rem"}}>{c.s}</div>}</div>;
              })}
            </div>
            <div style={st.card}>
              <h3 style={{marginTop:0}}>Analise por Familia</h3>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:"0.85rem"}}>
                  <thead><tr style={{borderBottom:"1px solid #334155"}}>
                    {["Familia","Total","Sadios","Atencao","Nao Sadios","% Problema","Faturamento 6M"].map(function(h){
                      return <th key={h} style={{padding:"0.7rem 0.5rem",textAlign:h==="Familia"?"left":"center",color:"#94a3b8",fontWeight:600}}>{h}</th>;
                    })}
                  </tr></thead>
                  <tbody>
                    {Object.keys(analysis.familias).sort(function(a,b){return a.localeCompare(b,"pt-BR");}).map(function(fn){
                      var f=analysis.familias[fn], pp=((f.produtosNaoSadios+f.produtosAtencao)/f.totalProdutos*100).toFixed(1);
                      return <tr key={fn} style={{borderBottom:"1px solid rgba(51,65,85,0.5)"}}>
                        <td style={{padding:"0.7rem 0.5rem",fontWeight:500}}>{fn}</td>
                        <td style={{textAlign:"center",padding:"0.7rem 0.5rem"}}>{f.totalProdutos}</td>
                        <td style={{textAlign:"center",padding:"0.7rem 0.5rem",color:"#4ade80"}}>{f.produtosSadios}</td>
                        <td style={{textAlign:"center",padding:"0.7rem 0.5rem",color:"#facc15"}}>{f.produtosAtencao}</td>
                        <td style={{textAlign:"center",padding:"0.7rem 0.5rem",color:"#f87171"}}>{f.produtosNaoSadios}</td>
                        <td style={{textAlign:"center",padding:"0.7rem 0.5rem"}}><span style={{padding:"2px 8px",borderRadius:999,fontSize:"0.75rem",background:parseFloat(pp)>50?"rgba(239,68,68,0.15)":parseFloat(pp)>30?"rgba(234,179,8,0.15)":"rgba(34,197,94,0.15)",color:parseFloat(pp)>50?"#f87171":parseFloat(pp)>30?"#facc15":"#4ade80"}}>{pp}%</span></td>
                        <td style={{textAlign:"right",padding:"0.7rem 0.5rem"}}>R$ {f.totalFaturamento.toLocaleString("pt-BR",{minimumFractionDigits:2})}</td>
                      </tr>;
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{textAlign:"right"}}><button onClick={exportReport} style={{display:"inline-flex",alignItems:"center",gap:8,padding:"0.7rem 1.5rem",background:"#16a34a",border:"none",borderRadius:8,color:"#fff",fontWeight:600,cursor:"pointer"}}><Download size={18}/>Exportar Relatorio</button></div>
          </div>
        )}

        {/* POR FAMILIA */}
        {activeTab==="familias" && analysis && (
          <div>
            <div style={{marginBottom:"1.5rem"}}>
              <label style={{display:"block",color:"#cbd5e1",fontSize:"0.85rem",marginBottom:6}}>Selecione uma Familia</label>
              <select value={selFamily||""} onChange={function(e){setSelFamily(e.target.value);}} style={{width:"100%",background:"#1e293b",border:"1px solid #334155",borderRadius:8,padding:"0.75rem 1rem",color:"#fff",fontSize:"0.9rem",outline:"none"}}>
                <option value="">-- Selecione --</option>
                {Object.keys(analysis.familias).sort(function(a,b){return a.localeCompare(b,"pt-BR");}).map(function(f){return <option key={f} value={f}>{f}</option>;})}
              </select>
            </div>
            {selFamily && analysis.familias[selFamily] && (function(){
              var fam = analysis.familias[selFamily];
              return (
                <div>
                  <div style={st.card}>
                    <h3 style={{marginTop:0,fontSize:"1.3rem"}}>{selFamily}</h3>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"1rem",fontSize:"0.85rem"}}>
                      {[{l:"Total",v:fam.totalProdutos},{l:"Nao Sadios",v:fam.produtosNaoSadios,c:"#f87171"},{l:"Media Venda/Mes",v:fam.mediaVendaFamilia.toFixed(1)},{l:"Faturamento",v:"R$ "+fam.totalFaturamento.toLocaleString("pt-BR",{minimumFractionDigits:2})}].map(function(c,i){
                        return <div key={i}><div style={{color:"#94a3b8",fontSize:"0.75rem"}}>{c.l}</div><div style={{fontWeight:700,fontSize:"1.2rem",color:c.c||"#fff"}}>{c.v}</div></div>;
                      })}
                    </div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:"1rem"}}>
                    {fam.produtos.slice().sort(function(a,b){return b.pontuacaoRisco-a.pontuacaoRisco;}).map(function(p,i){
                      return (
                        <div key={i} style={{background:cardBg(p.status),border:"1px solid "+statusBorder(p.status),borderRadius:12,padding:"1.2rem"}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"1rem"}}>
                            <div><div style={{fontWeight:700,fontSize:"1rem"}}>{p.descricao}</div><div style={{color:"#94a3b8",fontSize:"0.78rem"}}>Codigo: {p.codigoBarras}</div></div>
                            <span style={{padding:"4px 12px",borderRadius:999,fontSize:"0.8rem",fontWeight:600,background:statusBg(p.status),display:"flex",alignItems:"center",gap:4,whiteSpace:"nowrap"}}>
                              {p.status==="nao sadio"?<TrendingDown size={13}/>:p.status==="atencao"?<AlertCircle size={13}/>:<TrendingUp size={13}/>}
                              {p.status==="nao sadio"?"NAO SADIO":p.status==="atencao"?"ATENCAO":"SADIO"}
                            </span>
                          </div>
                          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"0.8rem",marginBottom:"0.8rem",fontSize:"0.82rem"}}>
                            {[
                              {l:"Curva",v:p.curva,c:p.curva==="A"?"#4ade80":p.curva==="B"?"#60a5fa":p.curva==="C"?"#facc15":"#f87171"},
                              {l:"Venda/Mes",v:p.vendaMensal.toFixed(1)},
                              {l:"Estoque",v:p.estoque+" ("+p.giroEstoque.toFixed(1)+"m)",c:p.giroEstoque>12?"#f87171":p.giroEstoque>6?"#facc15":"#4ade80"},
                              {l:"Markdown",v:p.markdown.toFixed(1)+"%",c:(p.percentualMarkdown||0)>110?"#4ade80":(p.percentualMarkdown||0)<50?"#f87171":"#fff"}
                            ].map(function(c,j){ return <div key={j}><div style={{color:"#94a3b8",fontSize:"0.7rem"}}>{c.l}</div><div style={{fontWeight:700,color:c.c||"#fff"}}>{c.v}</div></div>; })}
                          </div>
                          <div style={{padding:"0.6rem 0.8rem",borderRadius:8,marginBottom:"0.6rem",background:p.pontuacaoRisco>=8?"rgba(239,68,68,0.2)":p.pontuacaoRisco>=5?"rgba(234,88,12,0.2)":p.pontuacaoRisco>=3?"rgba(234,179,8,0.2)":"rgba(34,197,94,0.2)",border:"1px solid "+(p.pontuacaoRisco>=8?"#dc2626":p.pontuacaoRisco>=5?"#ea580c":p.pontuacaoRisco>=3?"#d97706":"#16a34a"),fontSize:"0.85rem",fontWeight:600}}>
                            {p.pontuacaoRisco>=8?"🚨":p.pontuacaoRisco>=5?"⚠️":p.pontuacaoRisco>=3?"⚡":"✅"} {p.acaoRecomendada}
                          </div>
                          {p.pontosPositivos && p.pontosPositivos.length>0 && (
                            <div style={{padding:"0.7rem 0.8rem",background:"rgba(34,197,94,0.08)",border:"1px solid rgba(20,83,45,0.5)",borderRadius:8,marginBottom:"0.6rem"}}>
                              {p.pontosPositivos.map(function(pt,idx){ return <div key={idx} style={{fontSize:"0.8rem",color:"#4ade80",marginBottom:2}}>{"✅ "+pt}</div>; })}
                            </div>
                          )}
                          {p.criteriosNaoSadios && p.criteriosNaoSadios.length>0 && (
                            <div style={{padding:"0.8rem",background:"rgba(15,23,42,0.5)",borderRadius:8,border:"1px solid "+(p.status==="nao sadio"?"rgba(127,29,29,0.5)":"rgba(113,63,18,0.5)")}}>
                              <div style={{fontWeight:600,marginBottom:6,fontSize:"0.82rem",color:statusColor(p.status),display:"flex",alignItems:"center",gap:6}}><AlertCircle size={13}/>Pontos de atencao</div>
                              {p.criteriosNaoSadios.map(function(c,idx){ return <div key={idx} style={{fontSize:"0.8rem",color:"#cbd5e1",marginBottom:3}}>{"• "+c}</div>; })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* RELATORIO */}
        {activeTab==="relatorio" && analysis && (
          <div style={st.card}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1.5rem"}}>
              <h2 style={{margin:0}}>Relatorio Executivo</h2>
              <button onClick={exportReport} style={{display:"inline-flex",alignItems:"center",gap:8,padding:"0.6rem 1.2rem",background:"#16a34a",border:"none",borderRadius:8,color:"#fff",fontWeight:600,cursor:"pointer",fontSize:"0.85rem"}}><Download size={16}/>Exportar .txt</button>
            </div>
            <div style={{background:"rgba(15,23,42,0.5)",border:"1px solid #334155",borderRadius:12,padding:"1.2rem",marginBottom:"1rem"}}>
              <h3 style={{marginTop:0,color:"#22d3ee"}}>Resumo</h3>
              {[["Total",analysis.resumo.totalProdutos,"#fff"],["Sadios",analysis.resumo.totalSadios+" ("+analysis.resumo.percentualSadios+"%)","#4ade80"],["Atencao",analysis.resumo.totalAtencao+" ("+analysis.resumo.percentualAtencao+"%)","#facc15"],["Nao Sadios",analysis.resumo.totalNaoSadios+" ("+analysis.resumo.percentualNaoSadios+"%)","#f87171"],["Faturamento","R$ "+analysis.resumo.totalFaturamento.toLocaleString("pt-BR",{minimumFractionDigits:2}),"#fff"],["Familias",analysis.resumo.totalFamilias,"#fff"]].map(function(r){
                return <div key={r[0]} style={{display:"flex",justifyContent:"space-between",padding:"0.5rem 0",borderBottom:"1px solid #334155",fontSize:"0.9rem"}}><span style={{color:"#94a3b8"}}>{r[0]}</span><span style={{fontWeight:700,color:r[2]}}>{r[1]}</span></div>;
              })}
            </div>
            <div style={{background:"rgba(15,23,42,0.5)",border:"1px solid #334155",borderRadius:12,padding:"1.2rem"}}>
              <h3 style={{marginTop:0,color:"#c084fc"}}>Por Familia</h3>
              {Object.keys(analysis.familias).sort(function(a,b){return (analysis.familias[b].produtosNaoSadios/analysis.familias[b].totalProdutos)-(analysis.familias[a].produtosNaoSadios/analysis.familias[a].totalProdutos);}).map(function(fn){
                var f=analysis.familias[fn], pct=(f.produtosNaoSadios/f.totalProdutos*100);
                return <div key={fn} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"0.6rem 0.8rem",background:"rgba(30,41,59,0.5)",borderRadius:8,marginBottom:6}}>
                  <div><div style={{fontWeight:500}}>{fn}</div><div style={{color:"#94a3b8",fontSize:"0.75rem"}}>{f.totalProdutos} produtos</div></div>
                  <div style={{textAlign:"right"}}><div style={{fontWeight:700,color:pct>50?"#f87171":pct>30?"#facc15":"#4ade80"}}>{pct>50?"🔴 Critica":pct>30?"🟡 Atencao":"🟢 Saudavel"}</div><div style={{color:"#94a3b8",fontSize:"0.75rem"}}>{f.produtosNaoSadios} nao sadios</div></div>
                </div>;
              })}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════
// ROOT
// ════════════════════════════════════════════════════
export default function App() {
  const [session, setSession] = useState(SESSION);
  const [view, setView]       = useState(SESSION ? "app" : "login");

  function handleLogin(s)  { setSession(s); setView("app"); }
  function handleLogout()  { SESSION=null; setSession(null); setView("login"); }

  if (view==="login") return <LoginScreen onLogin={handleLogin}/>;
  if (view==="admin") return <AdminPanel currentUser={session} onBack={function(){setView("app");}}/>;
  return <MainApp session={session} onLogout={handleLogout} onAdminPanel={function(){setView("admin");}}/>;
}